module.exports = __webpack_public_path__ + "static/fonts/Linearicons-Free.b9b7f23.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Linearicons-Free.eot?w118d
// module id = BUQd
// module chunks = 1